import React from 'react';

import Tag from 'components/shared/Tag/Tag';
import { getTagStyle } from 'components/shared/Tags/lib/tagColorOptions';

const TagPill = ({ tag, onRemove, className, title, size = 'medium' }) => {
  const { border } = getTagStyle(tag?.color);

  return (
    <Tag
      color={tag?.color}
      borderColor={border}
      size={size}
      icon={tag?.important ? 'info-mono' : undefined}
      iconColor="neutral"
      close={!!onRemove}
      onRemove={onRemove}
      removeValue={tag}
      className={className}
      truncate
      title={title}>
      {tag?.name}
    </Tag>
  );
};

export default TagPill;
